import { Button, InputLabel, OutlinedInput, Stack, Switch, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { DeleteForm, GetFieldIsValidAndErrorMessage } from "../../../Redux/Reducers/redux-slice-form-validation";
import { useAppSelector } from "../../../Redux/redux-store";
import FormInputText from "../../Forms/FormInputText/form-input-text";
import { useTranslation } from "react-i18next";

export type ModalDuplicateRowNameElementProps = {
  originalName: string;
  onConfirm?: (placeholderName: string) => void;
};

export type ModalDuplicateRowNameProps = CommonModalProps<ModalDuplicateRowNameElementProps>;

const ModalDuplicateRowName = React.forwardRef<any, ModalDuplicateRowNameProps>((props, ref) => {
  const { t } = useTranslation();
  const { originalName, closeModal, onConfirm } = props;

  const [placeholderName, setPlaceholderName] = useState(originalName);

  const isFieldValid = !useAppSelector(GetFieldIsValidAndErrorMessage("duplicate-row", "row-name"));

  const handleConfirmClick = () => {
    onConfirm && onConfirm(placeholderName);
    closeModal();
  };

  const handleCancelClick = () => {
    closeModal();
  };

  useEffect(() => {
    return () => {
      DeleteForm({ formId: "duplicate-row" });
    };
  }, []);

  return (
    <Modal title={t("modal:title.nameDuplicatedRow")} reference={ref} closeModal={handleCancelClick} width={600}>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <FormInputText
            placeholder={t("field:placeholder.rowName")}
            label={t("field:placeholder.rowName")}
            validationProps={{
              formId: "duplicate-row",
              fieldId: "row-name",
              minLength: 10,
              required: true,
            }}
            value={placeholderName}
            onChange={(event) => setPlaceholderName(event.target.value)}
          />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button
            color="success"
            variant="outlined"
            onClick={handleConfirmClick}
            // TODO : change this by passing it by props and put a default ?
            disabled={!isFieldValid}
          >
            {t("common:confirm")}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
});

export default ModalDuplicateRowName;
